import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "../../styles/upload-transcript.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserEdit,
  faSearchLocation,
  faFileEdit,
  faArrowLeft,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { Modal } from "react-bootstrap";

import "ag-grid-community/styles/ag-theme-alpine.css";
import { useEffect, useState } from "react";
import { REACT_APP_PEOPLESOFT_API } from "../../creds";
import UserModal from "../Modal/UserModal";
import LawFirmModal from "../Modal/LawFirmModal";
import { USERS_TYPES, ROLES, BOND_STATUS, INTEREST_TYPE, SECURITY_TYPE, BOND_STATUS_LABEL, BOND_STATUS_VALUE } from "../../types";
import {
  isBondCounselUser,
  isOfficeOfTheAttorneyGeneralUser,
  isDisabledBasedOnBusinessLogic,
  roleFilteredBondStatus,
} from "../../services/AuthorizationRules";
import CurrencyInput from "../../components/CurrencyInput";
import {
  uploadBondDataService,
  calculateFeeAmountDeu,
} from "../../services/BondsServices";
import RelatedBondModal from "../Modal/RelatedBondModal";
import { useOktaAuth } from "@okta/okta-react";
import DateLimitations from "../../components/DateLimitations";

const CloseButton = (props) => {
  return (<button type="button" class="btn-close btn-close-white" aria-label="Close" {...props}></button>)
}

const UploadTranscript = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userInformation, setInformation] = useState(null);
  const [stepNo, setStepNo] = useState(1);
  const [error, setError] = useState("");
  const [uploadData, setUploadData] = useState({});
  const [showUserParaLegalUserPicker, setShowParaLegalUserPicker] =
    useState(false);
  const [paraLegalUser, setParaLegalUser] = useState([]);
  
  const [showWarning, setShowWarning] = useState(false);

  const [submitted, setSubmitted] = useState(true);
  

  const [showUserAagPicker, setShowAagUserPicker] = useState(false);
  const [aAgUserFromPicker, setAagUserFromPicker] = useState([]);

  const [showBondCounselUserPicker, setShowBondCounselUserPicker] =
    useState(false);
  const [selectedBondCounselUser, setSelectedBondCounselUser] = useState([]);

  const [showLegalAssistantUserPicker, setShowLegalAssistantUserPicker] =
    useState(false);
  const [selectedLegalAssistantUser, setSelectedLegalAssistantUser] = useState(
    []
  );
  const [showSuccessModal, setShowSuccessModal] = useState();
  const [currentBondNumber, setCurrentBondNumber] = useState('')

  const [showLawFirmPicker, setShowLawFirmPicker] = useState(false);
  const [selectedLawFirm, setSelectedLawFirm] = useState("");
  const [showRelatedBondPicker, setShowRelatedBondPicker] = useState(false);
  const [selectedRelatedBond, setSelectedRelatedBond] = useState([]);
  const [maxDate, setMaxDate] = useState('');
  const [showQuoteWarning, setShowQuoteWarning] = useState(false);
  const [quoteFields, setQuoteFields] = useState([]);
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 3 }, (_, i) => currentYear - 1 + i);
  console.log('navigate', JSON.stringify(navigate))
  useEffect(() => {
    setInformation(user.userinfo);
  }, [user]);

  let USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  // function setData(name, value) {
  //   const tempData = uploadData;
  //   tempData[name] = value;
  //   setUploadData({ ...tempData });
  // }

  useEffect(() => {
    if (authState?.isAuthenticated) {
      setIsLoggedIn(true)
    }
  }, [authState]);
  console.log(user.userinfo, 'info')
  useEffect(() => {
    setData("bondcounsel_userinfo", selectedBondCounselUser);
    setData("paralegal_userinfo", paraLegalUser);
    const aagUser = aAgUserFromPicker[0];

    setData("aag_userinfo", aagUser);
  }, [selectedBondCounselUser, paraLegalUser, aAgUserFromPicker]);

  useEffect(() => {
    const legalAssistantUser = selectedLegalAssistantUser[0];
    setData("legal_assistant_userinfo", legalAssistantUser);
  }, [selectedLegalAssistantUser]);

  useEffect(() => {
    setData(
      "fee_amount_due",
      calculateFeeAmountDeu(uploadData["par_dollar_amount"])
    );
  }, [uploadData["par_dollar_amount"]]);

  useEffect(() => {
    if (user?.userinfo?.role == ROLES.BOND_COUNSEL_USER) {
      setSelectedLawFirm(user?.userinfo?.law_firm);
      setData("law_firm", user?.userinfo?.law_firm);
    } else {
      setData("law_firm", selectedLawFirm);
    }
  }, [selectedLawFirm]);

  useEffect(() => {
    setData("related_bonds", selectedRelatedBond);
  }, [selectedRelatedBond]);

  const fieldDisplayNames = {
    Issuer: "Issuer",
    title: "Issuance Title",
    authority: "Authority",
    comments: "Comments",
    // add other fields if needed
  };

  const handleOpenParaLegalUserModal = () => {
    setShowParaLegalUserPicker(true);
  };

  const handleOpenAagUserModal = () => {
    setShowAagUserPicker(true);
  };

  const handleWarningClose = () => {
    setShowWarning(false)
  }

  const handleOpenBondCounselUserModal = () => {
    setShowBondCounselUserPicker(true);
  };

  const handleOpenLawFirmModal = () => {
    setShowLawFirmPicker(true);
  };
  const handleCloseBondCounselUserModal = () => {
    setData("bondcounsel_userinfo", selectedBondCounselUser);
    setShowBondCounselUserPicker(false);
  };
  const handleCloseParaLegalUserModal = () => {
    setData("paralegal_userinfo", paraLegalUser);
    setShowParaLegalUserPicker(false);
  };

  const handleCloseLawFirmModal = () => {
    setData("law_firm", selectedLawFirm);
    setShowLawFirmPicker(false);
  };

  const handleOpenLegalAssistUserModal = async () => {
    setShowLegalAssistantUserPicker(true);
  };
  const handleCloseLegalAssistUserModal = async () => {
    setShowLegalAssistantUserPicker(false);
  };

  const handleCloseAagUserModal = async () => {
    setShowAagUserPicker(false);
  };
  const handleOpenRelatedBondsModal = () => {
    setShowRelatedBondPicker(true);
  };
  const handleCloseRelatedBondModal = () => {
    setShowRelatedBondPicker(false);
  };

  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
    navigate(`/bond-details/${currentBondNumber}/edit`);
  }

  const setData = (field, value, isInitial = false) => {
    if(field === 'bondcounsel_userinfo' || field === 'paralegal_userinfo' || field === 'aag_userinfo') {
      const tempData = uploadData;
      tempData[field] = value;
      setUploadData({ ...tempData });
    }
    let _bondPageData = uploadData;
    if (field === 'twdb' && value && uploadData['is_tea'] == '1') {
      _bondPageData = {
        ..._bondPageData,
        [field]: value,
        ['is_tea']: '0'
      }
      setShowWarning(true)
    }
    else if (field === 'is_tea' && value && uploadData['twdb'] == '1') {
      _bondPageData = {
        ..._bondPageData,
        [field]: value,
        ['twdb']: '0'
      }
      setShowWarning(true)
    }
    else {
      _bondPageData = {
        ..._bondPageData,
        [field]: value,
      }
    }
    setUploadData(_bondPageData);
    if (!isInitial) {
      setSubmitted(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === '"') {
      e.preventDefault(); // prevent typing double quote
    }
  }

  const onClickNextStep = () => {
    const textFields = ["Issuer", "title", "authority", "comments"];
    // Check for any fields containing a quotation mark (")
    // Find fields with quotes
    const fieldsWithQuotes = textFields.filter(
      (field) => uploadData[field]?.includes('"')
    );

    if (fieldsWithQuotes.length > 0) {
      // Show modal with friendly field names
      setQuoteFields(fieldsWithQuotes.map(f => fieldDisplayNames[f] || f));
      setShowQuoteWarning(true);
      return; // stop save
    }

    // ✅ No invalid fields, proceed as usual
    // Your existing next step logic here
    proceedToNextStep(); // <-- replace this with your current next-step function
  }

  const proceedToNextStep = () =>{
    setError("");
    if (stepNo === 1) {
      if (
        uploadData["law_firm"] === undefined ||
        uploadData["law_firm"].length === 0
      ) {
        setError("Law firm can not be blank");
      } else if (uploadData["bondcounsel_userinfo"].length === 0) {
        setError("Bond counsel name can not be blank");
      } else {
        setStepNo(stepNo + 1);
      }
    }

    if (stepNo === 2) {
      if (
        uploadData["Issuer"] === undefined ||
        uploadData["Issuer"].length === 0
      ) {
        setError("Issuer can not be blank");
      } else if (
        uploadData["title"] === undefined ||
        uploadData["title"].length === 0
      ) {
        setError("Title can not be blank");
      } else if (
        uploadData["par_dollar_amount"] === undefined
      ) {

        setError("Par dollar amount can not be blank");
      } else if (uploadData["par_dollar_amount"] <= 0) {
        setError("Par dollar amount value should be greater than Zero");
      }

      else if (
        uploadData["closing_date"] === undefined ||
        uploadData["closing_date"].length === 0
      ) {
        setError("Closing date can not be blank");
      } else {
        setStepNo(stepNo + 1);
      }
    }
  }

  function onClickPrevStep() {
    setStepNo(stepNo - 1);
  }
  function onCLickCancel() {
    navigate("/");
  }

  function submitData() {
    console.log("uploadData ", uploadData);
    sendData(uploadData);
  }

  async function sendData(data) {
    try {
      const uploaded_by = user?.userinfo?.email;
      data.email_address = uploaded_by;
      const json = await uploadBondDataService(data);
      setCurrentBondNumber(json[0].bond_issue_number)
      console.log("uploadBondDataService: ", json);
      console.log(json);
      console.log(json[0].StatusCode);

      if (json[0].StatusCode == 200) {
        setSubmitted(true);
        setShowSuccessModal(true)
      }

    } catch (error) {
      console.log("uploadBondDataService: ", error);
    }
  }

  if (!isLoggedIn) {
    return navigate("/");
  }


  

  return (
    <div class="upload-transaction-section">
      <div className="upload-transcript-container">

        <div className="row">
          <div className="col-md-3"></div>
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-12">
                <h2 className="upload-transcript-title">Upload Transcript</h2>
                <div className="box-steps">
                  <ul className="stepper">
                    <li className={stepNo === 1 ? "active" : ""}>
                      <span className="vline"></span>
                      <span className="stepper-circle">01</span>
                      Contact Information
                    </li>
                    {/* <li className={`text-center ${stepNo >= 1 ? "completed" : ""}`}>
                      <span className="vline"></span>
                    </li> */}
                    <li className={stepNo === 2 ? "active" : ""}>
                      <span className="vline"></span>
                      <span className="stepper-circle">02</span>
                      Public Security Information
                    </li>
                    {/* <li className={`text-center ${stepNo >= 2 ? "completed" : ""}`}>
                      <span className="vline"></span>
                    </li> */}
                    <li className={stepNo > 2 ? "active" : ""} style={{fontSize: "95%"}}>
                      <span className="vline"></span>
                      <span className="stepper-circle">03</span>
                      Public Security Information (Cont)
                    </li>
                  </ul>
                </div>
                <div
                  className={
                    error.length ? "login-box mt-0 pt-2" : "login-box mt-0 pt-0"
                  }
                >
                  {error.length ? (
                    <div className="alert alert-danger mt-3 mb-3">{error}</div>
                  ) : (
                    <div></div>
                  )}
                  {stepNo === 1 ? (
                    <div className="step-content">
                      <div className="row mb-3">
                        <div className="col-md-12 mb-3">
                          <div className="row">
                            <div className="col-md-3">
                              <label
                                className="form-label "
                                style={{ fontSize: "0.9em" }}
                              >
                                Law Firm(*)
                              </label>
                            </div>
                            <div className="col-md-9">
                              <div className="input-group">
                                {selectedLawFirm && (<input
                                  type="text"
                                  className="form-control"
                                  disabled={user?.userinfo?.role === ROLES.BOND_COUNSEL_USER}
                                  name="law_firm"
                                  value={selectedLawFirm}
                                // onChange={(e) => setData("law_firm", e.target.value)}
                                />
                                )}
                                {!isBondCounselUser(user) && (
                                  <i onClick={() => handleOpenLawFirmModal()}>
                                    <FontAwesomeIcon icon={faSearchLocation} />
                                  </i>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 mb-3">
                          <div className="row">
                            <div className="col-md-3">
                              <label
                                className="form-label"
                                style={{ fontSize: "0.9em" }}
                              >
                                Bond Counsel Name(*)
                              </label>
                            </div>
                            <div className="col-md-9">
                              <div className="input-group">
                                {selectedBondCounselUser &&
                                  selectedBondCounselUser.map((user, index) => (
                                    <div key={index}>
                                      <label
                                        key={index}
                                        title={
                                          "Email: " +
                                          user.EmailID +
                                          "\nPhone: " +
                                          user.Phone
                                        }
                                        style={{
                                          //  display: 'flex',
                                          marginRight: "10px", // Optional: add some space between labels
                                          padding: "6px 12px",
                                          border: "1px solid #ccc",
                                          borderRadius: "4px",
                                        }}
                                      >
                                        {user.FirstName + " " + user.LastName}
                                      </label>
                                    </div>
                                  ))}
                                <i
                                  onClick={() => {
                                    if (selectedLawFirm) {
                                      handleOpenBondCounselUserModal()
                                    }
                                  }}
                                >
                                  <FontAwesomeIcon icon={faUserEdit} />
                                </i>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12 mb-3">
                          <div className="row">
                            <div className="col-md-3">
                              <label
                                className="form-label"
                                style={{ fontSize: "0.9em" }}
                              >
                                Paralegal/Assistant Name
                              </label>
                            </div>
                            <div className="col-md-9">
                              <div className="input-group">
                                {paraLegalUser &&
                                  paraLegalUser.map((user, index) => (
                                    <div key={index}>
                                      <label
                                        key={index}
                                        title={
                                          "Email: " +
                                          user.EmailID +
                                          "\nPhone: " +
                                          user.Phone
                                        }
                                        style={{
                                          display: "flex",
                                          marginRight: "10px", // Optional: add some space between labels
                                          padding: "6px 12px",
                                          border: "1px solid #ccc",
                                          borderRadius: "4px",
                                        }}
                                      >
                                        {user.FirstName + " " + user.LastName}
                                      </label>
                                    </div>
                                  ))}
                                <i
                                  onClick={() => handleOpenParaLegalUserModal()}
                                >
                                  <FontAwesomeIcon icon={faUserEdit} />
                                </i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row justify-content-center mb-3">
                        {/* <div className="col-md-auto">
                          <button
                            className="btn btn-light"
                            onClick={() => onCLickCancel()}
                          >
                            Cancel
                          </button>
                        </div> */}
                        <div className="col-md-auto">
                          <button
                            className="btn btn-primary"
                            onClick={() => onClickNextStep()}
                          >
                            Continue
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : stepNo === 2 ? (
                    <div className="step-content">
                      <div className="row mb-4">
                        <div className="col-md-4 my-0">
                          <label
                            className="form-label"
                            style={{ fontSize: "0.9em" }}
                          >
                            Issuer(*)
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="Issuer"
                            value={
                              uploadData["Issuer"] ? uploadData["Issuer"] : ""
                            }
                            onChange={(e) => setData("Issuer", e.target.value)}
                            onKeyDown={handleKeyDown}
                          />
                        </div>
                        <div className="col-md-4 my-0">
                          <label
                            className="form-label"
                            style={{ fontSize: "0.9em" }}
                          >
                            Issuance Title(*)
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="title"
                            value={
                              uploadData["title"] ? uploadData["title"] : ""
                            }
                            onChange={(e) => setData("title", e.target.value)}
                            onKeyDown={handleKeyDown}
                          />
                        </div>
                        <div className="col-md-4 my-0">
                          <label
                            className="form-label"
                            style={{ fontSize: "0.9em" }}
                          >
                            Par Dollar Amount(*)
                          </label>
                          <CurrencyInput
                            field={"par_dollar_amount"}
                            selectedData={uploadData}
                            setData={setData}
                            isDisabledBasedOnBusinessLogic={false}
                          />
                        </div>
                      </div>
                      <div className="row mb-4">
                        <div className="col-md-4 my-0">
                          <label
                            className="form-label"
                            style={{ fontSize: "0.9em" }}
                          >
                            Traditional or Conduit
                          </label>
                          <select
                            className="form-control"
                            name="traditional_or_conduit"
                            defaultValue={
                              uploadData["traditional_or_conduit"]
                                ? uploadData["traditional_or_conduit"]
                                : -1
                            }
                            onChange={(e) =>
                              setData("traditional_or_conduit", e.target.value)
                            }
                          >
                            <option value="-1">Select Option</option>
                            <option value="0">Traditional</option>
                            <option value="1">Conduit</option>
                          </select>
                        </div>
                        <div className="col-md-4 my-0">
                          <label
                            className="form-label"
                            style={{ fontSize: "0.9em" }}
                          >
                            Closing Date(*)
                          </label>
                          <input
                            type="date"
                            min={new Date().toISOString().split("T")[0]}
                            className="form-control"
                            name="closing_date"
                            value={
                              uploadData["closing_date"]
                                ? uploadData["closing_date"]
                                : ""
                            }
                            onKeyDown={(e) => e.preventDefault()}
                            onChange={(e) => {
                              console.log(e.target.value, 'inpur repsone')
                              if (!/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) return;
                              setData(
                                "closing_date",
                                e.target.value
                              )
                            }
                            }
                          />
                        </div>

                        <div className="col-md-4 my-0">
                          <label
                            className="form-label"
                            style={{ fontSize: "0.9em" }}
                          >
                            Opinion Requested Date
                          </label>
                          <DateLimitations closingDate={uploadData["closing_date"]}
                            type="date"
                            className="form-control"
                            name="opinion_requested_by"
                            value={
                              uploadData["opinion_requested_by"]
                            }
                            onKeyDown={(e) => e.preventDefault()}
                            onChangeHandler={(e) =>
                              setData("opinion_requested_by", e.target.value)
                            }
                            valueData={uploadData}
                            fieldName={"opinion_requested_by"}
                            disabled={isDisabledBasedOnBusinessLogic(
                              user,
                              uploadData,
                              "opinion_requested_by"
                            )}
                          />
                        </div>
                      </div>

                      <div className="row mb-4">
                        <div className="col-md-4 my-0">
                          <label
                            className="form-label"
                            style={{ fontSize: "0.9em" }}
                          >
                            Preliminary Letter Requested
                          </label>
                          <DateLimitations closingDate={uploadData["closing_date"]}

                            type="date"
                            className="form-control"
                            name="preliminary_letter_requested"
                            value={
                              uploadData["preliminary_letter_requested"]
                                ? uploadData["preliminary_letter_requested"]
                                : ""
                            }
                            onKeyDown={(e) => e.preventDefault()}
                            onChangeHandler={(e) =>
                              setData(
                                "preliminary_letter_requested",
                                e.target.value
                              )
                            }
                            valueData={uploadData}
                            fieldName={"preliminary_letter_requested"}
                            disabled={isDisabledBasedOnBusinessLogic(
                              user,
                              uploadData,
                              "preliminary_letter_requested"
                            )}
                          />
                        </div>
                        <div className="col-md-4 my-0">
                          <label
                            className="form-label"
                            style={{ fontSize: "0.9em" }}
                          >
                            Transcript Status
                          </label>
                          <select
                            className="form-control"
                            name="bond_status"
                            disabled="true"
                            defaultValue={
                              uploadData["bond_status"]
                                ? uploadData["bond_status"]
                                : -1
                            }
                            onChange={(e) =>
                              setData("bond_status", BOND_STATUS_VALUE.New)
                            }
                          >
                            <option key={BOND_STATUS_VALUE.New} value={BOND_STATUS_VALUE.New}>
                              {BOND_STATUS_LABEL.New}
                            </option>
                          </select>
                        </div>
                     {/*   <div className="col-md-4 my-0">
                          {/* <label
                            className="form-label"
                            style={{ fontSize: "0.9em" }}
                          >
                            Multiple Series
                          </label> */}
                        {/*  <div className="input-group">
                            {uploadData["related_bonds"] &&
                              uploadData["related_bonds"].map(
                                // (relatedBond, index) => (
                                //   <div key={relatedBond.bond_issue_number}>
                                //     <label
                                //       key={index}
                                //       title={`Issue Number: ${relatedBond.bond_issue_number}\nTitle: ${relatedBond.title}`}
                                //       style={{
                                //         display: "flex",
                                //         marginRight: "10px", // Optional: add some space between labels
                                //         padding: "6px 12px",
                                //         border: "1px solid #ccc",
                                //         borderRadius: "4px",
                                //       }}
                                //     >
                                //       <a
                                //         href={`/bond-details/${relatedBond.bond_issue_number}/edit`} // Replace with your actual URL structure
                                //         style={{
                                //           textDecoration: "underline",
                                //           marginRight: "8px"
                                //         }}
                                //         target="_self"
                                //         rel="noopener noreferrer"
                                //       >
                                //         {relatedBond.bond_issue_number}
                                //       </a>
                                //       <span style={{ color: "#666" }}>  {/* Added a span for the title */}
                             {/*   //         - {relatedBond.title}
                                //       </span>

                                //     </label> */}
                          {/*        //   </div>
                                // )
                              )}
                            {/* {
                              <i onClick={handleOpenRelatedBondsModal}>
                                <FontAwesomeIcon icon={faFileEdit} />
                              </i>
                            } 
                         // </div> 
                       // </div> */}  
                       <div className="col-md-4 my-0">
                          <label
                            className="form-label"
                            style={{ fontSize: "0.9em" }}
                          >
                            Issue Year
                          </label>
                          <div className="input-group">
                            <select
                              value={uploadData["issue_year"] || ""}
                              onChange={(e) =>
                                setData("issue_year", e.target.value)
                              }
                              className="form-control"
                            >
                              <option value="">Select Year</option>
                              {years.map((year) => (
                                <option key={year} value={year}>
                                  {year}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div> 
                      
                      <div className="row mb-4">
                        
                        <div className="col-md-4 my-0">
                          <div className="input-group">
                            <label
                              className="form-label"
                              style={{ fontSize: "0.9em" }}
                            >
                              Fee amount Due
                            </label>
                            <CurrencyInput
                              field={"fee_amount_due"}
                              selectedData={uploadData}
                              setData={setData}
                              isDisabledBasedOnBusinessLogic={true}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 my-0">
                          <label
                            className="form-label"
                            style={{ fontSize: "0.9em" }}
                          >
                            Fee Amount Paid Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            name="fee_amount_paid"
                            value={
                              uploadData["fee_amount_paid"]
                                ? uploadData["fee_amount_paid"]
                                : ""
                            }
                            onChange={(e) =>
                              setData(
                                "fee_amount_paid",
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div className="col-md-4 my-0">
                          <label
                            className="form-label"
                            style={{ fontSize: "0.9em" }}
                          >
                            Interest Type
                          </label>
                          <div className="input-group">
                            <select
                              value={uploadData["interest_type"]}
                              onChange={(e) =>
                                setData(
                                  "interest_type",
                                  e.target.value
                                )
                              }
                              className="form-control"
                            >
                              {INTEREST_TYPE.map((status) => (
                                <option key={status.value} value={status.value}>
                                  {status.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row mb-4">
                        {/* <div className="col-md-4 my-0">
                          <label
                            className="form-label"
                            style={{ fontSize: "0.9em"}}
                          >
                            Security Type
                          </label>
                          <div className="input-group">

                            <select
                              value={uploadData["security_type"]}
                              onChange={(e) =>
                                setData(
                                  "security_type",
                                  e.target.value
                                )
                              }
                              className="form-control"
                            >
                              {SECURITY_TYPE.map((status) => (
                                <option key={status.value} value={status.value}>
                                  {status.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div> */}
                        
                        <div className="col-md-4 my-0">
                          <label className="form-label">Authority</label>
                          <input
                            type="text"
                            className="form-control"
                            name="authority"
                            value={
                              uploadData["authority"]
                                ? uploadData["authority"]
                                : ""
                            }
                            onChange={(e) =>
                              setData("authority", e.target.value)
                            }
                            onKeyDown={handleKeyDown}
                          />
                        </div>
                        <div className="col-md-4 my-0">

                        </div>
                      </div>
                      <div className="row justify-content-center mb-3">
                        <p style={{color: "red"}}>** Warning! Do not enter any quotation marks in any field. Using quotation marks will create a coding conflict that will prevent further use of the TTR system. Contact  
                          <a className="btn-link" href="mailto:bond.registration@cpa.texas.gov"> bond.registration@cpa.texas.gov</a>.</p>
                      </div>

                      <div className="row justify-content-center mb-3">
                        {/* <div className="col-md-auto">
                          <button
                            className="btn btn-light"
                            onClick={() => onCLickCancel()}
                          >
                            Cancel
                          </button>
                        </div> */}
                        <div className="col-md-auto">
                          <button
                            className="btn btn-primary"
                            onClick={() => onClickPrevStep()}
                          >
                            <FontAwesomeIcon icon={faArrowLeft} className="btn-icon"></FontAwesomeIcon>
                            Back
                          </button>
                        </div>
                        <div className="col-md-auto">
                          <button
                            className="btn btn-primary"
                            onClick={() => onClickNextStep()}
                          >
                            Continue
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="step-content">
                      <div className="row mb-4">
                        <div className="col-md-4 my-0">
                          <label className="form-label">TEFRA Opinion</label>
                          <div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="tefra_opinion1"
                                name="tefra_opinion"
                                value="0"
                                checked={
                                  uploadData["tefra_opinion"] === "0"
                                    ? true
                                    : false
                                }
                                onChange={(e) =>
                                  setData("tefra_opinion", e.target.value)
                                }
                              />
                              <label className="form-check-label">No</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="tefra_opinion2"
                                name="tefra_opinion"
                                value="1"
                                checked={
                                  uploadData["tefra_opinion"] === "1"
                                    ? true
                                    : false
                                }
                                onChange={(e) =>
                                  setData("tefra_opinion", e.target.value)
                                }
                              />
                              <label className="form-check-label">Yes</label>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 my-0">
                          <label className="form-label">TX Water Development Board</label>
                          <div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="twdb1"
                                name="twdb"
                                value="0"
                                checked={
                                  uploadData["twdb"] === "0" ? true : false
                                }
                                onChange={(e) =>
                                  setData("twdb", e.target.value)
                                }
                              />
                              <label className="form-check-label">No</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="twdb2"
                                name="twdb"
                                value="1"
                                checked={
                                  uploadData["twdb"] === "1" ? true : false
                                }
                                onChange={(e) =>
                                  setData("twdb", e.target.value)
                                }
                              />
                              <label className="form-check-label">Yes</label>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 my-0">
                          <label className="form-label">1371 Proceedings</label>
                          <div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="1371_proceedings1"
                                name="1371_proceedings"
                                value="0"
                                checked={
                                  uploadData["1371_proceedings"] === "0"
                                    ? true
                                    : false
                                }
                                onChange={(e) =>
                                  setData("1371_proceedings", e.target.value)
                                }
                              />
                              <label className="form-check-label">No</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="-1371_proceedings2"
                                name="1371_proceedings"
                                value="1"
                                checked={
                                  uploadData["1371_proceedings"] === "1"
                                    ? true
                                    : false
                                }
                                onChange={(e) =>
                                  setData("1371_proceedings", e.target.value)
                                }
                              />
                              <label className="form-check-label">Yes</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mb-4">
                        <div className="col-md-4 my-0">
                          <label className="form-label">
                            Public Security Included?
                          </label>
                          <div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="is_public_security_included1"
                                name="is_public_security_included"
                                value="0"
                                checked={
                                  uploadData["is_public_security_included"] ===
                                    "0"
                                    ? true
                                    : false
                                }
                                onChange={(e) =>
                                  setData(
                                    "is_public_security_included",
                                    e.target.value
                                  )
                                }
                              />
                              <label className="form-check-label">No</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="-is_public_security_included2"
                                name="is_public_security_included"
                                value="1"
                                checked={
                                  uploadData["is_public_security_included"] ===
                                    "1"
                                    ? true
                                    : false
                                }
                                onChange={(e) =>
                                  setData(
                                    "is_public_security_included",
                                    e.target.value
                                  )
                                }
                              />
                              <label className="form-check-label">Yes</label>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 my-0">
                          <label className="form-label">Boundary Change</label>
                          <div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="annexation1"
                                name="annexation"
                                value="0"
                                checked={
                                  uploadData["annexation"] === "0"
                                    ? true
                                    : false
                                }
                                onChange={(e) =>
                                  setData("annexation", e.target.value)
                                }
                              />
                              <label className="form-check-label">No</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="annexation2"
                                name="annexation"
                                value="1"
                                checked={
                                  uploadData["annexation"] === "1"
                                    ? true
                                    : false
                                }
                                onChange={(e) =>
                                  setData("annexation", e.target.value)
                                }
                              />
                              <label className="form-check-label">Yes</label>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 my-0">
                          <label className="form-label">Creation</label>
                          <div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="creation1"
                                name="creation"
                                value="0"
                                checked={
                                  uploadData["creation"] === "0" ? true : false
                                }
                                onChange={(e) =>
                                  setData("creation", e.target.value)
                                }
                              />
                              <label className="form-check-label">No</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="creation2"
                                name="creation"
                                value="1"
                                checked={
                                  uploadData["creation"] === "1" ? true : false
                                }
                                onChange={(e) =>
                                  setData("creation", e.target.value)
                                }
                              />
                              <label className="form-check-label">Yes</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mb-4">
                        <div className="col-md-4 my-0">
                          <label className="form-label">Election</label>
                          <div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="election1"
                                name="election"
                                value="0"
                                checked={
                                  uploadData["election"] === "0" ? true : false
                                }
                                onChange={(e) =>
                                  setData("election", e.target.value)
                                }
                              />
                              <label className="form-check-label">No</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="election2"
                                name="election"
                                value="1"
                                checked={
                                  uploadData["election"] === "1" ? true : false
                                }
                                onChange={(e) =>
                                  setData("election", e.target.value)
                                }
                              />
                              <label className="form-check-label">Yes</label>
                            </div>
                          </div>
                        </div>
                        {/* <div className="col-md-4 my-0">
                          <label className="form-label">Refunding</label>
                          <div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="refunding1"
                                name="refunding"
                                value="0"
                                checked={
                                  uploadData["refunding"] === "0" ? true : false
                                }
                                onChange={(e) =>
                                  setData("refunding", e.target.value)
                                }
                              />
                              <label className="form-check-label">No</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="refunding2"
                                name="refunding"
                                value="1"
                                checked={
                                  uploadData["refunding"] === "1" ? true : false
                                }
                                onChange={(e) =>
                                  setData("refunding", e.target.value)
                                }
                              />
                              <label className="form-check-label">Yes</label>
                            </div>
                          </div>
                        </div> */}
                        <div className="col-md-4 my-0">
                          <label className="form-label">TX Education Agency</label>
                          <div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="is_tea"
                                name="is_tea"
                                value="0"
                                checked={
                                  uploadData["is_tea"] === "0" ? true : false
                                }
                                onChange={(e) =>
                                  setData("is_tea", e.target.value)
                                }
                              />
                              <label className="form-check-label">No</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="is_tea2"
                                name="is_tea"
                                value="1"
                                checked={
                                  uploadData["is_tea"] === "1" ? true : false
                                }
                                onChange={(e) =>
                                  setData("is_tea", e.target.value)
                                }
                              />
                              <label className="form-check-label">Yes</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mb-4">
                      </div>
                      <div className="row justify-content-center mb-3">
                        {/* <div className="col-md-auto">
                          <button
                            className="btn btn-light"
                            onClick={() => onCLickCancel()}
                          >
                            Cancel
                          </button>
                        </div> */}
                        <div className="col-md-auto">
                          <button
                            className="btn btn-primary"
                            onClick={() => onClickPrevStep()}
                          >
                            <FontAwesomeIcon icon={faArrowLeft} className="btn-icon"></FontAwesomeIcon>
                            Back
                          </button>
                        </div>
                        <div className="col-md-auto">
                          <button
                            className="btn btn-primary"
                            onClick={() => submitData()}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3"></div>
        </div>
      </div>
      <div>
        {/* BondCounsel selection ------------------------- */}
        <Modal
          show={showBondCounselUserPicker}
          onHide={handleCloseBondCounselUserModal}
          size="lg"
          dialogClassName="custom-modal-size select-user-modal"
          style={{ maxWidth: "90%", width: "90%" }}
        >
          <Modal.Header>
            <div>
              Select {USERS_TYPES.BOND_COUNSEL} User
            </div>
            <CloseButton onClick={handleCloseBondCounselUserModal} />
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
            <div size="auto">
              <UserModal
                userIdentifier={USERS_TYPES.BOND_COUNSEL}
                existingUser={selectedBondCounselUser}
                setUser={setSelectedBondCounselUser}
                setSubmitted={setSubmitted}
                onHide={handleCloseBondCounselUserModal}
                lawFirm={selectedLawFirm}
              />
            </div>
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>

        {/* Paralegal user selection ------------------------- */}
        <Modal
          show={showUserParaLegalUserPicker}
          onHide={handleCloseParaLegalUserModal}
          size="lg"
          dialogClassName="custom-modal-size select-user-modal"
          style={{ maxWidth: "90%", width: "90%" }}
        >
          <Modal.Header>
            <div>
              Select {USERS_TYPES.PARA_LEGAL} User
            </div>
            <CloseButton onClick={handleCloseParaLegalUserModal} />
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
            <div size="auto">
              <UserModal
                userIdentifier={USERS_TYPES.PARA_LEGAL}
                existingUser={paraLegalUser}
                setUser={setParaLegalUser}
                setSubmitted={setSubmitted}
                onHide={handleCloseParaLegalUserModal}
                lawFirm={selectedLawFirm}
              />
            </div>
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      </div>

      {/* {This is to display if user inputs any " invalid fields in the text fields} */}
      <div>
        {/* Quotation Mark Warning Modal */}
        <Modal
          show={showQuoteWarning}
          onHide={() => setShowQuoteWarning(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Changes have not been saved</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Please remove quotation marks from the following fields:</p>
            <ul>
              {quoteFields.map((field, index) => (
                <li key={index}>{field}</li>
              ))}
            </ul>
          </Modal.Body>
          <Modal.Footer>
            <button variant="primary" onClick={() => setShowQuoteWarning(false)}>
              OK
            </button>
          </Modal.Footer>
        </Modal>

      </div>

      {/* aag user selection ------------------------- */}
      <div>
        <Modal
          show={showUserAagPicker}
          onHide={handleCloseAagUserModal}
          size="lg"
          dialogClassName="custom-modal-size"
          style={{ maxWidth: "90%", width: "90%" }}
        >
          <Modal.Header>
            <div>
              Select {USERS_TYPES.OAG} User
            </div>
            <CloseButton onClick={handleCloseAagUserModal} />
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
            <div size="auto">
              <UserModal
                userIdentifier={USERS_TYPES.OAG}
                setUser={setAagUserFromPicker}
                setSubmitted={setSubmitted}
                onHide={handleCloseAagUserModal}
                lawFirm={selectedLawFirm}
              />
            </div>
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      </div>
      {/* {This is to display if user inputs any " invalid fields in the text fields} */}
      <div>
        {/* Quotation Mark Warning Modal */}
        <Modal
          show={showQuoteWarning}
          onHide={() => setShowQuoteWarning(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Changes have not been saved</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Please remove quotation marks from the following fields:</p>
            <ul>
              {quoteFields.map((field, index) => (
                <li key={index}>{field}</li>
              ))}
            </ul>
          </Modal.Body>
          <Modal.Footer>
            <button variant="primary" onClick={() => setShowQuoteWarning(false)}>
              OK
            </button>
          </Modal.Footer>
        </Modal>

      </div>
      {/* Law firm  selection ------------------------- */}
      <div>
        <Modal
          show={showLawFirmPicker}
          onHide={handleCloseLawFirmModal}
          size="lg"
          dialogClassName="custom-modal-size"
          style={{ maxWidth: "90%", width: "90%" }}
        >
          <Modal.Header>
            <div>
            Select Law Firm
            </div>
            <CloseButton onClick={handleCloseAagUserModal} />
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
            <div size="auto">
              <LawFirmModal
                setLawFirm={setSelectedLawFirm}
                setSubmitted={setSubmitted}
                onHide={handleCloseLawFirmModal}
              />
            </div>
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>

        {/* Legal assistant selection ------------------------- */}
        <Modal
          show={showLegalAssistantUserPicker}
          onHide={handleCloseLegalAssistUserModal}
          size="lg"
          dialogClassName="custom-modal-size"
          style={{ maxWidth: "90%", width: "90%" }}
        >
          <Modal.Header closeButton>
            <div>
              Select User <br />
              <br />
            </div>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
            <div size="auto">
              <UserModal
                userIdentifier={USERS_TYPES.LEGAL_ASSISTANT}
                setUser={setSelectedLegalAssistantUser}
                setSubmitted={setSubmitted}
                onHide={handleCloseLegalAssistUserModal}
                lawFirm={selectedLawFirm}
              />
            </div>
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>

        {/* Related Bond selection ------------------------- */}
        <div>
          <Modal
            show={showRelatedBondPicker}
            onHide={handleCloseRelatedBondModal}
            size="lg"
            dialogClassName="custom-modal-size"
            style={{ maxWidth: "90%", width: "90%" }}
          >
            <Modal.Header closeButton>
              <div>
                Select Related Bond
                <br />
                <br />
              </div>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
              <div size="auto">
                <RelatedBondModal
                  mainBondId={uploadData["bond_issue_number"]}
                  existingRelatedBonds={uploadData["related_bonds"]}
                  setRelatedBond={setSelectedRelatedBond}
                  onHide={handleCloseRelatedBondModal}
                />
              </div>
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
          </Modal>
          <div>
            <Modal show={showWarning} centered onHide={handleWarningClose}>
              <Modal.Header closeButton>
              </Modal.Header>
              <Modal.Body>
                <div >
                  <p>TX Water Development Board and TX Education Agency cannot have same value</p>
                </div>
  
  
              </Modal.Body>
            </Modal>
          </div>
          {/* Saved successfully Modal */}
          <Modal
            show={showSuccessModal}
            onHide={handleCloseSuccessModal}
            size="lg"
            dialogClassName="custom-modal-size select-user-modal"
            style={{ maxWidth: "90%", width: "90%" }}
          >
            <Modal.Header>
              <div>
                <FontAwesomeIcon icon={faCheckCircle} className="btn-icon"></FontAwesomeIcon>Record Created Successfully
              </div>
              <CloseButton onClick={handleCloseSuccessModal} />
            </Modal.Header>
            <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
              <div size="auto">
                Your record has been successfully created.
              </div>
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default UploadTranscript;